import * as beneficiaryFormSchema from 'schemas/forms/BeneficiaryForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { format } from 'date-fns'
// import moment from 'moment'
import { validateAll, validateField } from 'utils/validators'
import { commonFunctions } from 'utils/CommonFunctions'
import React, { PropTypes, Component } from 'react'
import SelectInput from 'components/Form/components/SelectInput'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Radio from 'components/Form/components/Radio'
import styles from './BeneficiaryDisplayForm.scss'
import constants from 'constants'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'
import IndividualForm from './components/Beneficiary/IndividualForm'
import CompanyForm from './components/Beneficiary/CompanyForm'
import TrustForm from './components/Beneficiary/TrustForm'
import MinorForm from './components/Beneficiary/MinorForm'

class BeneficiaryDisplayForm extends Component {
  static propTypes = {
    beneficiaries: PropTypes.object,
    beneficiaryOptions: PropTypes.array,
    beneficiaryOptionLookup: PropTypes.object,
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hasFetched: PropTypes.bool,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
    // employeeId: PropTypes.string,
  }

  static defaultProps = {
    data: {},
    beneficiaryOptions: [],
    beneficiaryOptionLookup: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    hasFetched: false,
    id: '',
    title: '',
    beneficiaries: null,
    description: '',
    handleFormSubmit: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      beneficiaryTypeSelected: 'individual',
      disabledAmountField: false,
    }
  }

  componentWillMount() {
    const { formFields } = beneficiaryFormSchema
    const loadedType = this.props.data && this.props.data.type
      ? String(this.props.data.type).toLowerCase()
      : ''

    const formData = {
      formFields,
      data: this.props.data
        ? {
          ...this.props.data,
          type: loadedType || this.props.data.type,
        }
        : null,
    }

    if (loadedType) {
      this.setState({ beneficiaryTypeSelected: loadedType })
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const { beneficiaries } = this.props
    const modalCreated = this.props.modals.beneficiaryForm
    const modalChanged = modalCreated && nextProps.modals.beneficiaryForm.show !== this.props.modals.beneficiaryForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.beneficiaryForm.show
    const modalVisible = modalCreated && nextProps.modals.beneficiaryForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      
      this._handleChange('amountMax', beneficiaries.fixedRem)
      if (beneficiaries.beneficiary.beneficiaryId) {
        this._populateBeneficiaryForm(beneficiaries.beneficiary)
        if (beneficiaries.beneficiary.type) {
          this.setState({ beneficiaryTypeSelected: beneficiaries.beneficiary.type.toLowerCase() })
        }
      } else {
        // this._handleChange('effectiveDate', moment(beneficiaries.effectiveDate).format('DD/MM/YYYY'))
        this._handleChange('effectiveDate', (beneficiaries.effectiveDate ? format(new Date(beneficiaries.effectiveDate), constants.DATE_FORMAT.STANDARD_AU_NOTIME) : ''))
      }
    }

    /* if (this.props.data && modalChanged && modalVisible) {
      ("@@ this.props.data",this.props.data, "&& modalChanged",modalChanged,"&& modalVisible", modalVisible, "&&nextprops", nextProps.data)
      const data = {}
      const fields = this.props.data
      Object.keys(fields).forEach((key) => {
        if (key.indexOf('_') < 0) {
          const field = fields[key]
          let val
          if (Array.isArray(field)) {
            val = field.map((item, i) => {
              return {
                id: i + 1,
                label: item.name,
                value: item.id,
              }
            })
          } else {
            if (typeof field !== 'object' || field === null) val = field
            else {
              val = {
                label: field.name,
                value: field.id,
              }
            }
          }
          data[key] = val
        }
      })

      const formFields = beneficiaryFormSchema.formFields
      const formData = {
        formFields,
        data: data || null,
      }
      this.props.dispatch(formInit(this.props.id, formData))
    }    */
  }

  _populateBeneficiaryForm = (beneficiary, options = {}) => {
    const { preserveBeneficiaryId = false } = options

    if (!beneficiary) {
      return
    }

    if (!preserveBeneficiaryId) {
      this._handleChange('beneficiaryId', beneficiary.beneficiaryId || '')
    }
    this._handleChange('firstName', beneficiary.firstName || '')
    this._handleChange('lastName', beneficiary.lastName || '')
    this._handleChange('companyName', beneficiary.companyName || '')
    this._handleChange('trustName', beneficiary.trustName || '')
    this._handleChange('trusteeName', beneficiary.trusteeName || '')
    this._handleSelectChange('type', (beneficiary.type && beneficiary.type !== '' ? beneficiary.type.toLowerCase() : ''))
    this._handleChange('dob', beneficiary.dob || '')
    this._handleChange('tfn', beneficiary.tfn || '')
    this._handleChange('amountType', (beneficiary.amountType && beneficiary.amountType !== '' ? beneficiary.amountType.toLowerCase() : ''))
    this._handleChange('amount', (beneficiary.amountType && beneficiary.amountType !== '' ? commonFunctions.iff(String(beneficiary.amountType.toLowerCase()) !== 'max', beneficiary.amount, '0') : '0'))
    this._handleChange('effectiveDate', beneficiary.effectiveDate || '')
    this._handleChange('address1', beneficiary.address1 || '')
    this._handleChange('address2', beneficiary.address2 || '')
    this._handleChange('suburb', beneficiary.suburb || '')
    this._handleChange('city', beneficiary.city || '')
    this._handleChange('state', beneficiary.state || '')
    this._handleChange('postcode', beneficiary.postcode || '')
    this._handleChange('country', beneficiary.country || '')
    this._handleChange('amountMax', beneficiary.fixedRem || beneficiary.amountMax || '')
  }

  _schema = () => {
    const obj = {}
    beneficiaryFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    console.log(values)
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const isMinor = this.state.beneficiaryTypeSelected &&
      this.state.beneficiaryTypeSelected.toLowerCase() === constants.BENEFICIARY.TYPE.MINOR.toLowerCase()
    const requiredFields = isMinor
      ? beneficiaryFormSchema.requiredFields.filter(f => f.name !== 'tfn')
      : beneficiaryFormSchema.requiredFields
    const errors = validateAll(requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(data)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name, value) => {
    const form = this.props.forms[this.props.id]
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    if (name === 'amount' && form) {
      const schema = this._schema()
      const values = {
        ...form,
        amount: {
          ...form.amount,
          value,
        },
      }
      const validation = validateField([schema.amount], name, value, values)

      if (validation) {
        stateValue.data.error = validation.valid ? '' : validation.error
        stateValue.data.valid = validation.valid
      }
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    switch (name) {
      case 'amountType': {
        if (String(value) === 'fixed') {
          //console.log("beneficiary prop", this.props.beneficiaries)
          //console.log("beneficiary type", this.props.beneficiaries.beneficiary.type)
          if(this.state.beneficiaryTypeSelected.toLowerCase() === constants.BENEFICIARY.TYPE.MINOR.toLowerCase()){
            this.setState({ disabledAmountField: true })
            this._handleChange('amount', '416')
          }
          else
          {
            this.setState({ disabledAmountField: false })
            this._handleChange('amount', this.props.beneficiaries.beneficiary.amount)
          }
         
        } else if (String(value) === 'max') {
          // disable amount field and set the value to max
          // this._handleChange('amount', this.props.beneficiaries.fixedRem)
          this._handleChange('amount', '0')
          this.setState({ disabledAmountField: true })
        }
        break
      }
      case 'amount': {
        
        const form = this.props.forms && this.props.forms[this.props.id]
        const amountType = form && form.amountType ? String(form.amountType.value).toLowerCase() : ''
        const amountMax = form && form.amountMax ? this.props.beneficiaries.fixedRem : ''
        console.log("max amount", this.props.beneficiaries.fixedRem)

        // Keep fixed amount within the allowed remaining maximum.
    //    if (amountType === 'fixed' && amountMax !== '' && !isNaN(Number(value)) && Number(value) > Number(amountMax)) {
     //     stateValue.data.value = amountMax
    //    }
        break
      }
      default:
        break
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }

    switch (name) {
      case 'historicalData': {
        const selectedBeneficiary = this.props.beneficiaryOptionLookup[value]
        this._populateBeneficiaryForm(selectedBeneficiary, { preserveBeneficiaryId: true })
        if (selectedBeneficiary && selectedBeneficiary.type) {
          this._handleSelectChange('type', selectedBeneficiary.type.toLowerCase())
        }
        break
      }
      case 'type': {
        this.setState({ beneficiaryTypeSelected: value })
        if (String(value) === 'company' || (String(value) === 'trust')) {
          this._handleChange('dob', '')
        }
        else if (String(value) === 'minor') {
          this._handleChange('tfn', '99999')
        } else {
          this._handleChange('dob', (this.props.beneficiaries && this.props.beneficiaries.beneficiary && this.props.beneficiaries.beneficiary.dob ? this.props.beneficiaries.beneficiary.dob : ''))
        }
        break
      }
      default:
        break
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]

    const type = this.state.beneficiaryTypeSelected
      ? this.state.beneficiaryTypeSelected.toLowerCase()
      : null

    switch (type) {
      case constants.BENEFICIARY.TYPE.INDIVIDUAL.toLowerCase():
        return form.firstName.value && form.lastName.value && form.type.value
          && form.tfn.value && form.amountType.value
          && form.amount.value && form.address1.value
          && form.postcode.value
       case constants.BENEFICIARY.TYPE.MINOR.toLowerCase():
        return form.firstName.value && form.lastName.value && form.type.value
          && form.amountType.value
          && form.amount.value && form.address1.value
          && form.postcode.value
      case constants.BENEFICIARY.TYPE.COMPANY.toLowerCase():
        return form.companyName.value && form.type.value
        && form.tfn.value && form.amountType.value
        && form.amount.value && form.address1.value
        && form.postcode.value
      case constants.BENEFICIARY.TYPE.TRUST.toLowerCase():
        return form.trustName.value && form.type.value
        && form.tfn.value && form.amountType.value
        && form.amount.value && form.address1.value
        && form.postcode.value
      default:
        return false
    }
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      // frequencies,
      // groupsAndEntities,
      modals,
      // serviceTypes,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)

    const selectedType = this.state.beneficiaryTypeSelected
      ? this.state.beneficiaryTypeSelected.toLocaleLowerCase()
      : constants.BENEFICIARY.TYPE.INDIVIDUAL.toLocaleLowerCase()
    // const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="beneficiaryForm"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          <div>
            <SelectInput
              {...schema.historicalData}
              searchable
              handleChange={this._handleSelectChange}
              onBlur={this._handleValidation}
              options={this.props.beneficiaryOptions || []}
              value={form ? form.historicalData.value : ''}
            />
          </div>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader}>
              Beneficiary details
            </div>

            <fieldset>
              <ul>
                <li>
                  <TextInput
                    {...schema.beneficiaryId}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.beneficiaryId.value}
                  />
                  <TextInput
                    {...schema.amountMax}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.amountMax.value}
                  />
                  <SelectInput
                    {...schema.type}
                    searchable
                    error={form.type.error}
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={[{ value: 'company', label: 'Company' }, { value: 'individual', label: 'Individual' }, { value: 'trust', label: 'Trust' }, { value: 'minor', label: 'Minor' }]} // load from BED?
                    valid={form.type.valid}
                    value={form.type.value}
                  />
                </li>
                { selectedType === constants.BENEFICIARY.TYPE.INDIVIDUAL.toLocaleLowerCase() &&
                  <IndividualForm
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }
                 { selectedType === constants.BENEFICIARY.TYPE.MINOR.toLocaleLowerCase() &&
                  <MinorForm
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }
                { selectedType === constants.BENEFICIARY.TYPE.COMPANY.toLocaleLowerCase() &&
                  <CompanyForm
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }
                { selectedType === constants.BENEFICIARY.TYPE.TRUST.toLocaleLowerCase() &&
                  <TrustForm
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }
                { selectedType !== constants.BENEFICIARY.TYPE.MINOR.toLocaleLowerCase() &&
                  <li>
                    <TextInput
                      {...schema.tfn}
                      error={form.tfn.error}
                      focus={form.tfn.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.tfn.value}
                      valid={form.tfn.valid}
                    />
                  </li> }
                <li>
                  <Radio
                    horizontal
                    name="amountType"
                    onChange={this._handleChange}
                    options={[
                      { label: 'Fixed', value: 'fixed' },
                      { label: 'Max', value: 'max' },
                    ]}
                    value={form.amountType.value}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.amount}
                    disabled={this.state.disabledAmountField}
                    error={form.amount.error}
                    focus={form.amount.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.amount.value}
                    valid={form.amount.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.effectiveDate}
                    disabled
                    error={form.effectiveDate.error}
                    focus={form.effectiveDate.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.effectiveDate.value}
                  />
                </li>
                <div className={styles.sectionHeader}>
                  Beneficiary address
                </div>
                <li>
                  <TextInput
                    {...schema.address1}
                    error={form.address1.error}
                    focus={form.address1.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.address1.value}
                    valid={form.address1.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.address2}
                    error={form.address2.error}
                    focus={form.address2.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.address2.value}
                    valid={form.address2.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.suburb}
                    error={form.suburb.error}
                    focus={form.suburb.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.suburb.value}
                    valid={form.suburb.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.city}
                    error={form.city.error}
                    focus={form.city.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.city.value}
                    valid={form.city.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.state}
                    error={form.state.error}
                    focus={form.state.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.state.value}
                    valid={form.state.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.postcode}
                    error={form.postcode.error}
                    focus={form.postcode.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.postcode.value}
                    valid={form.postcode.valid}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.country}
                    error={form.country.error}
                    focus={form.country.focus}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.country.value}
                    valid={form.country.valid}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                isLarge
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

/* const mapStateToProps = (state) => ({
  beneficiaries: state.beneficiaries,
}) */

export default BeneficiaryDisplayForm
//



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/BeneficiaryDisplayForm.js